
import { server } from '../engine/server'

var RentlyIntegrationController = Class.create({
  	initialize: function() {
    },
    authenticate: function(username, password, callback) {
        var url = "integrations/rently/auth";
        const params = {
            username: username,
            password:password
        };

		var data = server.getData(url, params, true, "POST");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
    },
    getHubs: function(callback) {
        var url = "integrations/rently/hubs";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
    },
    addHub: function(id, level, building_id, callback) {
        var url = "integrations/rently/hubs/add";
        const params = {
            controller_id: id,
            building_id: building_id,
            level: level
        };

		var data = server.getData(url, params, true, "POST");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			callback(e);
		});
    },
    triggerLock: function(sensor, callback) {
        var url = "integrations/rently/devices/command";

		var data = server.getData(url, sensor, true, "PUT");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
    },
});

export let rentlyIntegrationController = new RentlyIntegrationController();


// WEBPACK FOOTER //
// app/core/controllers/RentlyIntegrationController.js